import React from 'react';
import { ChevronDown } from 'lucide-react';
interface SelectOption {
  value: string;
  label: string;
}
interface SelectProps extends React.SelectHTMLAttributes<HTMLSelectElement> {
  label?: string;
  options: SelectOption[];
  error?: string;
}
export function Select({
  label,
  options,
  error,
  className = '',
  id,
  ...props
}: SelectProps) {
  const selectId = id || props.name || Math.random().toString(36).substr(2, 9);
  return <div className="w-full" data-id="element-110">
      {label && <label htmlFor={selectId} className="block text-sm font-medium text-slate-700 mb-1" data-id="element-111">
          {label}
        </label>}
      <div className="relative" data-id="element-112">
        <select id={selectId} className={`appearance-none flex h-10 w-full rounded-md border border-slate-300 bg-white px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-emerald-500 focus:border-transparent disabled:cursor-not-allowed disabled:opacity-50 ${error ? 'border-red-500 focus:ring-red-500' : ''} ${className}`} {...props} data-id="element-113">
          {options.map(option => <option key={option.value} value={option.value} data-id="element-114">
              {option.label}
            </option>)}
        </select>
        <ChevronDown className="absolute right-3 top-3 h-4 w-4 text-slate-400 pointer-events-none" data-id="element-115" />
      </div>
      {error && <p className="mt-1 text-sm text-red-500" data-id="element-116">{error}</p>}
    </div>;
}